import { render, staticRenderFns } from "./invoiceterm.vue?vue&type=template&id=1df1e791"
import script from "./invoiceterm.vue?vue&type=script&lang=js"
export * from "./invoiceterm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports